module.exports = __webpack_public_path__ + "static/media/logo.b88bf1ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo.png
// module id = 91
// module chunks = 0